// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 7076 ? "actioncable" : chunkId) + "-" + {"7076":"b620979038332a945592","8072":"24fec24ac7faa8012346"}[chunkId] + ".chunk.js";
};